import { TOOL } from '../../constants';
import { getAvailableTools } from '../../reducers/utils/tool';
import type { AnnotationT } from '../../types';

/**
 * Merge/subtract produce a POLYGON. When every selected shape is a RECTANGLE,
 * polygon must be an allowed tool for the label or the result would be invalid.
 */
export function shouldEnableMergeSubtractForRectangleOnlyLabelWithoutPolygonTool(annotations: Array<AnnotationT>): boolean {
  if (annotations.length < 2) {
    return false;
  }
  const firstAnnotation = annotations[0];
  if (firstAnnotation === undefined) {
    return false;
  }
  const firstTitle = firstAnnotation.annotationLabel.title;
  if (annotations.some(a => a.annotationLabel.title !== firstTitle)) {
    return false;
  }
  return getAvailableTools(firstAnnotation.annotationLabel).includes(TOOL.POLYGON);
}